import { InfoCard } from '@dnb/eufemia';
import { BAID_MATCHER } from '@portals/shared/common/matchers';
import { ServiceNowBusinessApplicationDto, ServiceNowServiceOfferingDto } from '@portals/shared/portal/SupportTicket';

interface ServiceNowIdentifierInfoCardProps {
  data: ServiceNowBusinessApplicationDto | ServiceNowServiceOfferingDto;
}

export default function ServiceNowIdentifierInfoCard({ data }: ServiceNowIdentifierInfoCardProps) {
  const isValidBAIdentifier = 'businessApplicationId' in data ? BAID_MATCHER.test(data.businessApplicationId) : false;

  return (
    <InfoCard
      dropShadow={false}
      icon=""
      stretch
      text={
        'businessApplicationId' in data ? (
          <>
            {isValidBAIdentifier ? 'Business Application' : 'Service Offering'} ({data.businessApplicationId}
            )
            <br /> Approver: {data.itApplicationOwner}
          </>
        ) : (
          <>
            Service Offering ({data.number}
            )
            <br /> Approver: {data.managedBy}
          </>
        )
      }
      title={data.name}
    />
  );
}
